export const addNote = {
    namespaced: true,

    state: {
        session: {
            id: null,
            date: null,
            name: ''
        },

        note: null
    },

    actions: {
        setSessionDetails(context, payload) {
            Vue.set(context.state.session, 'id', payload.id);
            Vue.set(context.state.session, 'date', payload.date);
            Vue.set(context.state.session, 'name', payload.name);
        },

        setNote(context, payload) {
            Vue.set(context.state, 'note', payload);
        }
    }
};
